<template lang="pug">
AppSteppers(start-step-name='Данные пользователя')
  template(v-slot:default='{ prevStep, nextStep }')
    AppSteppersPane(step-name='Данные пользователя')
      DynamicAdditionalDataForm(:next-step='nextStep')
    AppSteppersPane(step-name='Оформление заявки')
      .consultation_modal_root
        .consultation_modal
          main.consultation_modal_form
            .consultation_block
              Select.consultation_block_select(
                :options='getOptions',
                placeholder='Тема обращения (обязательно к заполнению)',
                :required='true',
                :value='value',
                v-model='value'
              )
              Textarea.consultation_block_input(
                min-height='170px',
                placeholder='Текст обращения (обязательно к заполнению)',
                resize='vertical',
                v-model='value1'
              )
              .appendButton
                ExtButton(size='small', @click='$refs.inputFile.click()')
                  | выберите файлы
                  span *
                p(:title='getTitleFiles') {{ getFilesNames }}
              p.alertify(v-if='value2.length > 0') Вы можете загрузить один или несколько файлов одновременно. Последующая загрузка файлов приведет к замене уже загруженных файлов.
              p.title_files Допустимые типы файлов: GIF, JPG, TIF, PNG, pdf, zip. Общий объем загружаемых файлов - не более 2 мб.
              input.file_attach(
                style='display: none',
                ref='inputFile',
                name='attachments[]',
                type='file',
                accept='.gif,.jpg,.tif,.png,.pdf,.zip',
                @change='value2 = $event.target.files',
                multiple
              )
          .save_button_wrapper
            Button.save_button(@click='send(nextStep)', :disabled='!isActive') Сохранить
          p.alert.red(v-if='critError') {{ critError }}
          p.alert.red(v-else-if='error') Не заполнены обязательные поля
    AppSteppersPane(step-name='Статус')
      FinishMessage(
        :message='message',
        @understood='$ui.$modal.close("ConsultationModal")'
      )
</template>

<script>
import Button from '../../../pages/profile/blocks/cards/purchases/components/cancellation/components/button/Button.vue';
import Select from '../../form/Select.vue';
import Input from '../../../pages/profile/blocks/form/components/input/Input.vue';

import { Textarea } from '@/pages/profile/blocks';
import AppSteppers from '@/uikit/components/AppSteppers/AppSteppers.vue';
import AppSteppersPane from '@/uikit/components/AppSteppers/components/AppSteppersPane.vue';
import DynamicAdditionalDataForm from '@/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue';
import FinishMessage from '@/components/parts/catalog/card/components/request/components/finishMessage/FinishMessage.vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import ExtButton from '@/components/ext/Button.vue';
export default {
  name: 'ConsultationsModal',
  components: {
    AppButtonNew,
    FinishMessage,
    DynamicAdditionalDataForm,
    AppSteppersPane,
    AppSteppers,
    Input,
    Select,
    Button,
    Textarea,
    ExtButton,
  },
  inject: ['$api'],
  methods: {
    async send(next) {
      let data = this.value;
      let data1 = this.value1;
      let data2 = this.value2;
      if (!data || !data1) {
        this.error = true;
        return;
      }
      const formData = new FormData();
      formData.append('topic_id', data);
      formData.append('appeal', data1);
      for (let i = 0; i < data2.length; i++) {
        formData.append('consultation_files[]', data2[i]);
      }
      this.$api
        .post('consultation/create', formData)
        .then(() => {
          next();
        })
        .catch((e) => {
          console.log('strange error', { ...e });
          if (e.t0 && e.t0.response && e.t0.response.status === 413) {
            this.critError = 'Загруженные файлы в сумме превышают объем 2 мб. Чтобы отправить заявку, загрузите файлы меньшего размера.';
          } else if (e.response) {
            if (e.response.data && e.response.data.message) {
              this.critError = e.response.data.message;
            } else if (e.response.status === 413) {
              this.critError =
                'Загруженные файлы в сумме превышают объем 2 мб. Чтобы отправить заявку, загрузите файлы меньшего размера.';
            } else {
              this.critError =
                'Неизвестная ошибка, обратитесь к администратору.';
            }
          } else if (e.request) {
            this.critError = 'Загруженные файлы в сумме превышают объем 2 мб. Чтобы отправить заявку, загрузите файлы меньшего размера.';
          }
        });
    },
  },
  data() {
    return {
      message: {
        type: 'success',
        text: {
          description: 'Консультация создана успешно!',
          title: '',
          warning: '',
        },
      },
      value: '',
      value1: '',
      value2: [],
      error: false,
      critError: '',
    };
  },
  computed: {
    getTitleFiles() {
      return Array.from(this.value2)
        .map((el) => el.name)
        .join('\r\n');
    },
    getFilesNames() {
      if (!this.value2.length) {
        return 'Не выбрано';
      } else if (this.value2.length === 1) {
        return this.value2[0].name;
      } else {
        return `Файлов выбрано: ${this.value2.length}`;
      }
    },
    isActive() {
      return !!(this.value && this.value1 && this.value2.length);
    },
    getOptions() {
      return this.$store.state.consultationsTopics.map((elem) => {
        return {
          value: elem.id,
          text: elem.name,
        };
      });
    },
  },
};
</script>
<style scoped lang="stylus">
.title_files {
  font-size 12px
  padding-top 3px
}
.alertify {
  font-size 12px
  padding-top 3px
  color red
}
.alert {
  font-size 12px
}
.appendButton {
  display flex
  column-gap 7px
  align-items: center;
}
.red
  color red
.file_attach
  padding-bottom: 2px;
  margin: 5px 0;
.consultation_block_input
  padding-bottom 2px;
.consultation_modal_root
  display flex
  justify-content center
  width 100%
  height 100%
  margin-bottom 0
  .consultation_modal
    max-width: 480px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &_form
      padding-bottom 10px
.consultation_modal_header
  padding-bottom 10px
  display flex
  justify-content space-between
  &__close_btn
    padding 0 5px
    cursor pointer
.consultation_block_select
  width 100%
.save_button_wrapper
  display flex
  justify-content right
  .save_button
    padding-left 10px
    padding-right 10px
    border-radius 4px
    margin-bottom 10px
</style>



// WEBPACK FOOTER //
// ConsultationsModal.vue?32d6d674